var map = {
	"./DE.ts": [
		12,
		9,
		12
	],
	"./EN_US.ts": [
		216,
		9,
		872
	],
	"./custom.d.ts": [
		883,
		7,
		883
	],
	"./js/GraphAlgorithms.ts": [
		446,
		9,
		446
	],
	"./js/UIInteractions.ts": [
		825,
		9
	],
	"./js/app.ts": [
		238,
		9
	],
	"./js/classes/GraphImmut/EdgeImmut.ts": [
		268,
		9
	],
	"./js/classes/GraphImmut/GraphImmut.ts": [
		536,
		9
	],
	"./js/classes/GraphImmut/NodeImmut.ts": [
		729,
		9
	],
	"./js/classes/SpanningTree.ts": [
		866,
		9,
		866
	],
	"./js/dataImportExport.ts": [
		346,
		9,
		346
	],
	"./js/graphState.ts": [
		669,
		9
	],
	"./js/languages.ts": [
		119,
		9
	],
	"./js/main.ts": [
		863,
		9
	],
	"./js/settings.ts": [
		660,
		9
	],
	"./js/util/genericHelpers.ts": [
		485,
		9
	],
	"./js/util/graphHelpers.ts": [
		641,
		9
	],
	"./js/util/predefinedGraphs.ts": [
		133,
		9,
		981
	],
	"./js/workers/GraphAlgorithmWorker.ts": [
		69,
		9,
		69
	],
	"./js/workers/pwaServiceWorker.ts": [
		304,
		7,
		304
	],
	"./overloadTypes.d.ts": [
		595,
		7,
		595
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 529;
module.exports = webpackAsyncContext;